import { FC } from 'react';
import { AppBar, AppBarProps } from 'react-admin';

import Toolbar from '@mui/material/Toolbar';

import { CustomUserMenu } from '../CustomUserMenu';
import logo from './logo.png';
import './styles.css';

export const CustomAppBar = (props: FC<AppBarProps>) => {
  return (
    <AppBar
      sx={{
        maxHeight: 48,
        backgroundColor: '#19102A',
      }}
      {...props}
      color="primary"
      userMenu={<CustomUserMenu />}>
      <Toolbar sx={{ flex: 1 }}>
        <img src={logo} alt="logo" className="custom-app-bar_logo" />
      </Toolbar>
    </AppBar>
  );
};
